import {TCIAppStatusCategory} from "../tci";
import {IScribeSolution, SCRIBE_STATUS} from "./solutions";


export class ScribeAppStatus {
    public static getAppStatusCategory(status: string): TCIAppStatusCategory {
        let available = TCIAppStatusCategory.READY;

        if (status) {
            switch (status) {
                default:
                case SCRIBE_STATUS.OnDemand:
                case SCRIBE_STATUS.Idle:
                case SCRIBE_STATUS.OnDemandLastRunRowErrors:
                case SCRIBE_STATUS.IdleLastRunRowErrors:
                    available = TCIAppStatusCategory.READY;
                    break;
                case SCRIBE_STATUS.Starting:
                case SCRIBE_STATUS.Stopping:
                case SCRIBE_STATUS.InProgress:
                    available = TCIAppStatusCategory.IN_PROGRESS;
                    break;
                case SCRIBE_STATUS.Incomplete:
                case SCRIBE_STATUS.Preparing:
                case SCRIBE_STATUS.Disabled:
                case SCRIBE_STATUS.AgentUpdating:
                    available = TCIAppStatusCategory.NOT_READY;
                    break;
                case SCRIBE_STATUS.AgentHeartbeatLate:
                case SCRIBE_STATUS.IdleLastRunFailed:
                case SCRIBE_STATUS.OnDemandLastRunFailed:
                    available = TCIAppStatusCategory.WARNING;
                    break;
                case SCRIBE_STATUS.AgentShutdown:
                case SCRIBE_STATUS.AgentHeartbeatFailed:
                case SCRIBE_STATUS.ProvisionError:
                    available = TCIAppStatusCategory.ERROR;
                    break;
            }
        }

        return available;
    }


    /**
     * Status transitions to check if the solution is available
     * @param status
     */
    public static isAvailable(status: string): boolean {
        let available = false;
        if (status) {
            switch (status) {
                case SCRIBE_STATUS.OnDemandLastRunFailed:
                case SCRIBE_STATUS.OnDemandLastRunRowErrors:
                case SCRIBE_STATUS.OnDemand:
                case SCRIBE_STATUS.Idle:
                case SCRIBE_STATUS.IdleLastRunRowErrors:
                case SCRIBE_STATUS.IdleLastRunFailed:
                    available = true;
                    break;
                default:
                case SCRIBE_STATUS.Incomplete:
                case SCRIBE_STATUS.WaitingForEvent:
                case SCRIBE_STATUS.Stopping:
                case SCRIBE_STATUS.InProgress:
                case SCRIBE_STATUS.Preparing:
                case SCRIBE_STATUS.Starting:
                case SCRIBE_STATUS.Disabled:
                case SCRIBE_STATUS.AgentShutdown:
                case SCRIBE_STATUS.AgentHeartbeatFailed:
                case SCRIBE_STATUS.AgentHeartbeatLate:
                case SCRIBE_STATUS.ProvisionError:
                    available = false;
                    break;
            }
        }

        return available;
    }

    /**
     * Simple helper to check in progress
     * @param status
     */
    static isInProgress(status: string): boolean  {
        return status === "In Progress" ||  status === SCRIBE_STATUS.InProgress;
    }

    /**
     * Get the in progress message with a duration time
     * @param solution
     */
    static getSolutionStatus(solution: IScribeSolution | any): string {
        if (!solution || !solution.status) {
            return "";
        }
        return ScribeAppStatus.getDisplayStatus(solution.status);
    }

    /**
     * Get the text for describing the solution state
     * @param status
     */
    static getDisplayStatus(status: string): string {
        // Base display status on status
        switch (status) {
            // Status Enumeration
            case SCRIBE_STATUS.IdleLastRunRowErrors:
            case SCRIBE_STATUS.IdleLastRunFailed:
                return "Scheduled";
            case SCRIBE_STATUS.InProgress:
                return "Running";
            case SCRIBE_STATUS.Incomplete:
                return "Incomplete";
            case SCRIBE_STATUS.OnDemand:
            case SCRIBE_STATUS.OnDemandLastRunFailed:
            case SCRIBE_STATUS.OnDemandLastRunRowErrors:
            case SCRIBE_STATUS.WaitingForEvent:
                return "Ready";
            case SCRIBE_STATUS.AgentUpdating:
            case SCRIBE_STATUS.UpdatingConnector:
                return "Updating";
            case SCRIBE_STATUS.AgentShutdown:
            case SCRIBE_STATUS.AgentHeartbeatLate:
            case SCRIBE_STATUS.AgentHeartbeatFailed:
            case SCRIBE_STATUS.ProvisionError:
                return "Agent Issue";
            case SCRIBE_STATUS.WaitingToUpdateAgent:
            case SCRIBE_STATUS.WaitingToUpdateConnector:
                return "Pending Agent Update";

            case SCRIBE_STATUS.WaitingToRestartAgentUserRequest:
            case SCRIBE_STATUS.WaitingToRestartAgentMemoryLimit:
                return "Pending Agent Restart";
        }
        return status;
    }

    /**
     * Calculate the total time span from startTime until now
     * @param startTime
     */
    static getTimeSpan(startTime: Date): string {
        try {
            if (!startTime || !startTime.getTime) {
                return "";
            }
            const date1 = startTime;
            const date2 = new Date();
            let diff = date2.getTime() - date1.getTime();
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            diff -= days * (1000 * 60 * 60 * 24);
            const hours = Math.floor(diff / (1000 * 60 * 60));
            diff -= hours * (1000 * 60 * 60);
            let mins = Math.floor(diff / (1000 * 60));
            diff -= mins * (1000 * 60);
            // Negative is bad return blank
            if (days < 0 || hours < 0 || mins < 0) {
                return "";
            }
            let seconds = Math.floor(diff / (1000));
            // Negative seconds is bad return blank
            if (seconds < 0) {
                return "";
            }
            // I only have seconds so it is less than a minute
            if (isNaN(days) || isNaN(hours) || isNaN(mins) || (days === 0 && hours === 0 && mins === 0 && seconds > 0)) {
                return "(less than a minute)";
            }
            if (mins === 0) {
                mins = <any>"00";
            } else if (mins <= 9) {
                mins = <any>`0${mins}`;
            }
            if (seconds === 0) {
                seconds = <any>"00";
            } else if (seconds <= 9) {
                seconds = <any>`0${seconds}`;
            }
            if (days !== 0) {
                return `(${days} ${hours}:${mins}:${seconds} d h:m:s)`;
            } else if (hours !== 0) {
                return `(${hours}:${mins}:${seconds} h:m:s)`;
            } else {
                return `(${mins}:${seconds} m:s)`;
            }
        } catch (e) {
            return "(less than a minute)";
        }
    }
}
